module.exports = __webpack_public_path__ + "static/media/bg black copy 3.2f557d5f.svg";